import { render, staticRenderFns } from "./artisan.vue?vue&type=template&id=31c6f64a&scoped=true&"
import script from "./artisan.vue?vue&type=script&lang=js&"
export * from "./artisan.vue?vue&type=script&lang=js&"
import style0 from "./artisan.vue?vue&type=style&index=0&id=31c6f64a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c6f64a",
  null
  
)

export default component.exports